<section class="steps">
  <h2>{{ preferences.t('landing.steps.title') }}</h2>

  <div class="step-list">
    @for (step of steps; track step.key; let index = $index) {
      <article class="step-card">
        <div class="step-icon">
          @if (isInlineIcon(step.icon)) {
            <app-icon [name]="step.icon" />
          } @else {
            <img [src]="step.icon" alt="" />
          }
          <span>{{ index + 1 }}</span>
        </div>
        <div>
          <h3>{{ preferences.t('landing.steps.items.' + step.key + '.title') }}</h3>
          <p>{{ preferences.t('landing.steps.items.' + step.key + '.description') }}</p>
        </div>
      </article>
    }
  </div>

  <aside class="privacy-note">
    <app-icon name="shield" />
    <p>{{ preferences.t('landing.privacy') }}</p>
  </aside>
</section>
